module.exports = __webpack_public_path__ + "img/TradingView-icon15_jp.8a998945.svg";